
const app = {
    version: '0.0.1'
}

const api = {
    // rootPoint: 'https://sapi.hkrstore.com/api/v1'
    rootPoint: '/api'
}

export default {
    app,
    api
}
